module.exports = __webpack_public_path__ + "static/media/EditorsPick2.03c7ad54.png";